/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { common, Hub } from '@qwyk/models';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from '@qwyk/hub/environment';

@Injectable({
    providedIn: 'root',
})
export class PortalTeamsService {
    constructor(private http: HttpClient) {}

    public getTeams(
        query: any
    ): Observable<common.PaginatedResponse<Hub.CustomerTeam>> {
        let httpQuery = null;
        if (query) {
            httpQuery = new HttpParams({ fromObject: query });
        }

        return this.http
            .get<common.PaginatedResponse<Hub.CustomerTeam>>(
                `${environment.backendServer}/api/hub/administration/teams?${httpQuery}`
            )
            .pipe(take(1));
    }

    public getPortalTeam(id: string): Observable<Hub.CustomerTeam> {
        return this.http
            .get<{ data: Hub.CustomerTeam }>(
                `${environment.backendServer}/api/hub/administration/teams/${id}`
            )
            .pipe(
                take(1),
                map(response => response.data)
            );
    }

    public createPortalTeam(payload: any): Observable<Hub.CustomerTeam> {
        return this.http
            .post<{ data: Hub.CustomerTeam }>(
                `${environment.backendServer}/api/hub/administration/teams`,
                payload
            )
            .pipe(
                take(1),
                map(response => response.data)
            );
    }

    public updatePortalTeam(
        id: string,
        payload: any
    ): Observable<Hub.CustomerTeam> {
        return this.http
            .post<{ data: Hub.CustomerTeam }>(
                `${environment.backendServer}/api/hub/administration/teams/${id}`,
                payload
            )
            .pipe(
                take(1),
                map(response => response.data)
            );
    }

    public getTypes(): Observable<{ value: string; label: string }[]> {
        return of([
            { label: 'Company', value: 'company' },
            { label: 'Department', value: 'department' },
            { label: 'Other', value: 'other' },
        ]);
    }

    public getSegments(): Observable<{ value: string; label: string }[]> {
        return of([
            { label: 'Customer', value: 'customer' },
            { label: 'Agent', value: 'agent' },
            { label: 'Carrier', value: 'carrier' },
            { label: 'Internal', value: 'internal' },
            { label: 'Other', value: 'other' },
        ]);
    }

    public getOrganizationMaster(type: string): Observable<any[]> {
        return this.http
            .get<{ data: any[] }>(
                `${environment.backendServer}/api/hub/organization/masters/${type}?children=false`
            )
            .pipe(
                take(1),
                map(response => response.data)
            );
    }

    public getParentOptions(currentTeam?: Hub.CustomerTeam): Observable<any[]> {
        let suffix = '';
        if (currentTeam) {
            suffix = `?team_id=${currentTeam.id}`;
        }
        return this.http
            .get<any>(
                `${environment.backendServer}/api/hub/administration/teams/parent_options${suffix}`
            )
            .pipe(take(1));
    }

    getTeamHierarchy(team: Hub.CustomerTeam, includeParent: boolean) {
        const url = `${
            environment.backendServer
        }/api/hub/administration/teams/${team.id}/hierarchy${
            includeParent ? '?include_parent=true' : ''
        }`;
        return this.http.get<any>(url).pipe(take(1));
    }
}
